import {
  availableAvoidOptions,
  getAvailableAvoidOptions,
  optionLabel,
} from "@/components/maps/carRouteOptions"
import { MultiSelect } from "@/components/ui/multi-select"
import { useTranslation } from "react-i18next"
import { AvoidType } from "@/api/adHocCommands"
import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { selectRoutingProvider } from "@/reducers/serviceConfigSelectors"

export default function AvoidSelect({
  onClose,
  initialSelected = [],
}: {
  onClose: (selectedOptions: AvoidType[]) => void
  initialSelected?: AvoidType[]
}) {
  const { t } = useTranslation()
  const [selectedOptions, setSelectedOptions] =
    useState<AvoidType[]>(initialSelected)

  // Update internal state when initialSelected changes
  useEffect(() => {
    setSelectedOptions(initialSelected)
  }, [initialSelected])

  const routingProvider = useSelector(selectRoutingProvider)

  const options = useMemo(
    () =>
      getAvailableAvoidOptions(availableAvoidOptions, routingProvider).map(
        (option) => ({ ...option, label: optionLabel(t, option) }),
      ),
    [routingProvider, t],
  )

  return (
    <MultiSelect
      options={options}
      selected={selectedOptions}
      onClose={onClose}
      onChange={setSelectedOptions}
      placeholder={t("orders.transportOrder.avoid")}
    />
  )
}
